import { httpsCallable } from 'firebase/functions';
import { User, CreateUserData, UpdateUserData } from '../types/user';
import { functions } from '../config/firebase';

class UsersAPI {
  private functions = functions;

  async listUsers(): Promise<{ users: User[] }> {
    const adminUsers = httpsCallable(this.functions, 'adminUsers');
    const result = await adminUsers({});
    return result.data as { users: User[] };
  }

  async getUser(userId: string): Promise<{ user: User }> {
    const adminUsers = httpsCallable(this.functions, 'adminUsers');
    const result = await adminUsers({ userId });
    return result.data as { user: User };
  }

  async createUser(userData: CreateUserData): Promise<{ user: User }> {
    const adminCreateUser = httpsCallable(this.functions, 'adminCreateUser');
    const result = await adminCreateUser(userData);
    return result.data as { user: User };
  }

  async updateUser(userId: string, userData: UpdateUserData): Promise<{ user: User }> {
    const adminUpdateUser = httpsCallable(this.functions, 'adminUpdateUser');
    const result = await adminUpdateUser({ userId, ...userData });
    return result.data as { user: User };
  }

  async deleteUser(userId: string): Promise<{ success: boolean }> {
    const adminDeleteUser = httpsCallable(this.functions, 'adminDeleteUser');
    const result = await adminDeleteUser({ userId });
    return result.data as { success: boolean };
  }

  async setUserRole(userId: string, role: 'admin' | 'viewer' | 'analyst'): Promise<{ success: boolean }> {
    const adminSetUserRole = httpsCallable(this.functions, 'adminSetUserRole');
    const result = await adminSetUserRole({ userId, role });
    return result.data as { success: boolean };
  }
}

export const usersAPI = new UsersAPI();